import { FetchState } from "@/shared/types";
import * as userService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import * as _ from "lodash";
import { defineStore } from "pinia";
import { UserNoteState, UserNoteModel } from "../types";

export const initialState: UserNoteState = {
  fetchState: FetchState.Uninitialized,
  notes: [],
  username: ""
};

export const useUserNote = defineStore("userNote", {
  state: (): UserNoteState => (_.cloneDeep(initialState)),
  getters: {
    isLoaded: state => state.fetchState === FetchState.Loaded,
    isLoading: state => state.fetchState === FetchState.Loading,
    isFailed: state => state.fetchState === FetchState.Failed,
  },
  actions: {
    loadUserNotes (args: { username: string, partnerId: number }) {
      if (this.username === args.username || this.fetchState === FetchState.Loading) {
        return Promise.resolve();
      }

      this.fetchState = FetchState.Loading;

      return userService.getUserNotes(args)
        .then(response => {
          this.notes = response.data.notes;
          this.username = args.username;
          this.fetchState = FetchState.Loaded;
        })
        .catch(error => {
          this.notes = [];
          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
